import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TicketsContainer from "src/components/molecules/TicketsContainer";
import WorkRequestContainer from "src/components/molecules/WorkRequestContainer";
import { setPageNameHeader } from "src/redux/actions/header";
import { getUserData } from "src/redux/selectors/user";
import WorkRequestListContext from "src/pages/WorkRequests/context";
import { Ticket } from "src/types";

import { WORK_REQUEST_TYPE } from "../WorkRequests/constants";

const tabs = [
  {
    eventKey: WORK_REQUEST_TYPE.PREVENTATIVE_MAINTENANCE,
    label: "Preventative Maintenance",
  },
];

const PreventativeMaintenance = () => {
  const { isManager, isVendor } = useSelector(getUserData);
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState<string | null | undefined>(WORK_REQUEST_TYPE.PREVENTATIVE_MAINTENANCE);
  const [category, setCategory] = useState<string | null | undefined>(null);
  const [direction, setDirection] = useState<string | null | undefined>(null);
  const [searchText, setSearchText] = useState<string | null | undefined>(null);
  const [pageNumber, setPageNumber] = useState<number | null | undefined>(null);
  const [appliedSearch, setAppliedSearch] = useState<boolean | null | undefined>(null);
  const [selectedTicketForCloseAction, setSelectedTicketForCloseAction] = useState<Ticket | undefined>();
  const [selectedTicketForAssignResource, setSelectedTicketForAssignResource] = useState<Ticket | undefined>();

  useEffect(() => {
    dispatch(setPageNameHeader("Preventative Maintenance"));
  }, [dispatch]);

  return (
    <WorkRequestListContext.Provider
      value={{
        activeTab,
        setActiveTab,
        category,
        setCategory,
        direction,
        setDirection,
        searchText,
        setSearchText,
        pageNumber,
        setPageNumber,
        appliedSearch,
        setAppliedSearch,
        selectedTicketForCloseAction,
        setSelectedTicketForCloseAction,
        selectedTicketForAssignResource,
        setSelectedTicketForAssignResource,
      }}
    >
      {isManager ? (
        <WorkRequestContainer tabs={tabs} renderTable={<TicketsContainer isManager={true} />} />
      ) : isVendor ? (
        <WorkRequestContainer tabs={tabs} renderTable={<TicketsContainer isVendor={true} />} />
      ) : (
        <WorkRequestContainer tabs={tabs} renderTable={<TicketsContainer />} />
      )}
    </WorkRequestListContext.Provider>
  );
};

export default PreventativeMaintenance;
